module.exports = __webpack_public_path__ + "media/durango/SEED-846adff5.svg";